import React, { FunctionComponent } from 'react';
import { Accordion, AccordionDetails, Typography, Grid, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from '../../nurse-case-manager-summary/NurseCaseManagerSummary.Styles';
import ReferralContactEntity from '../../../../../entities/ReferralContact.Entity';
import StateEntity from '../../../../../entities/State.Entity';

interface ITcmNurseCaseManagerResponseProps {
    nurseCaseManager: ReferralContactEntity;
    states: Array<StateEntity>;
}

export const TcmNurseCaseManagerResponse: FunctionComponent<ITcmNurseCaseManagerResponseProps> = (
    props: ITcmNurseCaseManagerResponseProps,
) => {
    const classes = styles();
    const stateLabel = props.states?.find((x) => x.stateId === props.nurseCaseManager?.stateId)?.stateName;

    return (
        <Accordion defaultExpanded={true} className={classes.paper} square>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon className={classes.paperHeaderIcon} />}
                aria-controls="tcm-ncm-content"
                id="tcm-ncm-accordion"
                className={classes.paperHeader}
            >
                <Typography variant="subtitle2" className={classes.paperTitle}>
                    Nurse Case Manager
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            First Name
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.firstName}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Address Line 1
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.addressLine1}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Zip Code
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.zipCode}
                        </Typography>
                    </Grid>

                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Last Name
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.lastName}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Address Line 2
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.addressLine2}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Primary Phone
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.primaryPhoneNumber}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Ext
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.primaryPhoneExtension}
                        </Typography>
                    </Grid>

                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Company Name
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            City
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.cityName}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Fax
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.fax}
                        </Typography>
                    </Grid>

                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Email
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.nurseCaseManager?.email}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            State
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {stateLabel}
                        </Typography>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};
